import { render, staticRenderFns } from "./ProfileUsernameTab.vue?vue&type=template&id=0637f4fe"
import script from "./ProfileUsernameTab.vue?vue&type=script&lang=js"
export * from "./ProfileUsernameTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports